module.exports = __webpack_public_path__ + "img/ic_h5_vip.39c522c0.png";